import { Link } from 'react-router-dom';
import "./error.css"
function Error() {
    return (
        <div className="error-container">
            <h1>404!</h1>
            <p>Página não encontrada</p>
            <Link to="/" className="home-button">Voltar para Home</Link>
            
        </div>
    );
}

export default Error;
